import { ChangeEvent, useState } from 'react'
import { ImageUploadButton } from '../button/imageUploadButton'
import { ImageUploadPreviewModal } from '../modal/app_modals/ImagePreviewModal'
import { ImageBanner } from './imageBanner'

/**
 * A single image picker laid out like the product images: the uploaded image
 * as a thumbnail with a delete button, or an upload tile when there is none.
 * Hands back the uploaded URL, or null when the image is deleted.
 */
export function ImageUploadField({
  imageUrl,
  onChange,
  loading = false,
}: {
  imageUrl?: string | null
  onChange: (url: string | null) => void
  loading?: boolean
}) {
  const [file, setFile] = useState<File>()

  const pickFile = (event: ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files?.[0]
    if (selected) setFile(selected)
  }

  return (
    <>
      {imageUrl ? (
        <ImageBanner
          className="!h-[140px] !w-[140px]"
          imageUrl={imageUrl}
          loading={loading}
          onDelete={() => onChange(null)}
        />
      ) : (
        <ImageUploadButton
          showText
          handleChange={pickFile}
          className="!relative !rounded-lg size-[140px] !m-0 !top-0 !right-0"
          icon="pic-icon"
        />
      )}

      {file && (
        <ImageUploadPreviewModal
          image={file}
          open
          setOpen={(open) => {
            if (!open) setFile(undefined)
          }}
          onCloseCallback={() => setFile(undefined)}
          onSuccessCallback={onChange}
        />
      )}
    </>
  )
}
